import { Component, HostBinding, Input, OnDestroy, OnInit } from '@angular/core';
import { ColorPickerControl } from '@iplab/ngx-color-picker';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';
import { Subscription } from 'rxjs';

@Component({
  selector: 'mui-color-picker',
  templateUrl: './mui-color-picker.component.html',
  styleUrls: ['./mui-color-picker.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: MuiColorPicker
    }
  ]
})
export class MuiColorPicker implements ControlValueAccessor, OnInit, OnDestroy {
  get useAlpha(): boolean {
    return this._useAlpha;
  }

  @Input()
  set useAlpha(value: boolean) {
    this._useAlpha = value;
    if (this._useAlpha) {
      this.colorPickerControl.showAlphaChannel();
    } else {
      this.colorPickerControl.hideAlphaChannel();
    }
  }

  @HostBinding('class.mui-color-picker--selected')
  get isColorSelected(): boolean {
    return !!this.color;
  }

  @Input()
  @HostBinding('attr.aria-label')
  label = '';

  readonly colorPickerControl = new ColorPickerControl().hidePresets();
  disabled = false;
  onChange = (_: string | null): void => {
    /* noop */
  };
  onTouched = (): void => {
    /* noop */
  };

  @HostBinding('class.mui-color-picker')
  protected baseClass = true;

  protected hasFocus = false;
  protected color: string | null = '#ffffff';
  private _useAlpha = false;
  private _subscription: Subscription | null = null;

  constructor() {
    // Call setter to initialize alpha channel
    this.useAlpha = this._useAlpha;
  }

  ngOnInit(): void {
    this._subscription = this.colorPickerControl.valueChanges.subscribe((color) => {
      this.color = color ? color.toHexString(this.useAlpha) : null;
      this.onChange(this.color);
      this.onTouched();
    });
  }

  ngOnDestroy(): void {
    this._subscription?.unsubscribe();
  }

  writeValue(value: string): void {
    if (value) {
      this.colorPickerControl.setValueFrom(value);
    }
  }

  registerOnChange(fn: (color: string | null) => void): void {
    this.onChange = fn;
  }

  registerOnTouched(fn: () => void): void {
    this.onTouched = fn;
  }

  setDisabledState(isDisabled: boolean): void {
    this.disabled = isDisabled;
  }
}
